<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="signup container-fluid">
    <div class="row signup-page">
      <div class="col-lg-12">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
            <div class="logo_form"> <img :src="getTranslations.project_logo_img" alt=""> </div>
            <div class="form_title">
              <h1>{{ getTranslations.visitor_forgot_password_3_almost_done_msg }}</h1>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container">
              <div class="StandardRegSteps_step step_done">1</div>
              <div class="StandardRegSteps_step step_done">2</div>
              <div class="StandardRegSteps_step ">3</div>
            </div>
          </div>
          <div class="signup-form">
            <form action="">
              <p v-if="facebookFunctionality"></p>
              <div v-if="facebookFunctionality"
                   class="form-group form-group--icon fb_login"
                   :class="[ !errorInFb? '' : 'has-warning' ]">
                <facebook-login :enteredUsername="'User'"
                                :type="fbActionType"
                                :previousComponentFacebook="fbActionType"
                                @errorsUpdated="methodForEvent($event)">
                </facebook-login>
                <span v-if="facebookFunctionality && errorInFb"
                      class="form-group__feedback">{{ getMessage(errorInFb) }}
              </span>
              </div>
              <div v-if="facebookFunctionality"
                   class="form-group form-group--or">
                <div><span>{{ getTranslations.visitor_sign_up_and_login_or }}</span></div>
              </div>
              <div class="form-group form-group--icon"
                   :class="[ !hasErrorsPassword ? '' : 'has-warning' ]">
                <input type="password" class="form-group__textfield"
                       :class="[ !hasErrorsPassword ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_forgot_password_3_enter_password_placeholder_min_6_chars"
                       @keyup="checkPassword" v-model="user.password"/>
                <span v-show="getMessage(messageForPassword) && user.password" class="form-group__feedback">{{ getMessage(messageForPassword) }}</span>
                <!-- <span class="form-group__feedback">{{ getTranslations.visitor_forgot_password_3_warning_msg_at_least_1_digit) }}</span> -->
                <i class="icon-lock"></i>
              </div>
              <div class="form-group form-group--icon"
                   :class="[ !hasErrorsConfirmPassword ? '' : 'has-warning' ]">
                <input type="password" class="form-group__textfield"
                       :class="[ !hasErrorsConfirmPassword ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_forgot_password_3_confirm_password_placeholder"
                       @keyup="checkPassword"
                       v-model="user.confirmPassword"/>
                <span v-show="getMessage(messageForConfirmPassword) && user.confirmPassword"
                      class="form-group__feedback">{{ getMessage(messageForConfirmPassword) }}</span>
                <i class="icon-lock"></i>
              </div>
              <div class="form-group form-group--checkbox">
                <input id="remember_me" type="checkbox" value="remember_me_checked" v-model="checkedRememberMe"><label
                for="remember_me">{{ getTranslations.visitor_sign_up_3_remember_me }}</label>
              </div>
              <input type="submit" :value="getTranslations.visitor_forgot_password_3_reset_password"
                     :class="['btn btn--medium btn--main',( hasErrorsConfirmPassword || hasErrorsPassword? 'deactivated' : '')]" @click.prevent="checkButton">
              <!--<div class="form-footer">-->
                <!--{{ getTranslations.visitor_forgot_password_3_sign_up_terms_msg) }}<a>-->
                <!--<router-link to="/terms">{{ getTranslations.visitor_forgot_password_3_terms_and_conditions) }}</router-link>-->
              <!--</a>-->
              <!--</div>-->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import FacebookLogin from '.././FacebookLogin';


export default {
  name: 'forgotPassword3',
  components: { FacebookLogin },
  data() {
    return {
      testUser: 'User',
      errorInFb: null,
      fbActionType: 'login',
      user: {
        password: '',
        confirmPassword: '',
      },
      messageForPassword: '',
      messageForUsername: '',
      messageForConfirmPassword: '',
      hasErrorsUsername: false,
      hasErrorsPassword: false,
      hasErrorsConfirmPassword: false,
      message: '',
      checkedRememberMe: true,
    };
  },
  methods: {
    ...mapActions('profile', [
      'callForAuthorization',
      'resetPassword',
      'getUserLoginDetails',
    ]),
    methodForEvent(event) {
      this.errorInFb = event;
    },
    getMessage(key) {
      return this.getTranslations[key] || '';
    },
    clearData() {
      this.change();
      this.message = '';
      this.user.password = '';
      this.user.confirmPassword = '';
      this.messageForPassword = '';
      this.messageForConfirmPassword = '';
      this.hasErrorsPassword = false;
      this.hasErrorsConfirmPassword = false;
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /* eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          // e.which < 0x20, then it's not a printable character
          // e.which === 0 - Not a character
          return;     // Do nothing
        }
        if (value.length == max) {
          charCode.preventDefault();
//            return false;
        } else if (value.length > max) {
          // Maximum exceeded
//            this.user.password = this.user.password.substring(0, max);
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    checkPassword(evt) {
      const min = 4;
      const max = 4;
      this.messageForFinalPassword = '';
      this.messageForConfirmPassword = '';
      this.messageForPassword = '';
      this.finalMessage = '';
      this.errorInFb = false;
      // eslint-disable-next-line
      const validPasswordRegex = /^[0-9]{0,8}$/;
      // const validPasswordRegex = /^[a-z0-9@]+$/i; //mono arithmous grammata kai @ /tested in regex101.com
      // ^(?=.*[a-z])(?=.*\d)(?!.*\W)_?.+$ /?! negative lockhead _?(optional _ )
      // /^(?=.*[a-z])(?=.*\d)(?=.*_).+$/
      // https://stackoverflow.com/questions/1559751/regex-to-make-sure-that-the-string-contains-at-least-one-lower-case-char-upper
      const validPassword = this.user.password.match(validPasswordRegex);
      this.hasErrorsPassword = false;
      if (this.user.password.length < min || this.user.confirmPassword.length > max) {
        if (this.user.password.length < min) {
          this.messageForPassword = 'visitor_sign_up_3_info_wrong_password_warning_msg_at_least_6_chars';
          this.hasErrorsPassword = true;
        }
        if (this.user.confirmPassword.length > max) {
          this.user.confirmPassword = this.checkMaxChar(this.user.confirmPassword, max, evt);
          this.checkPassword();
        }
      } else if (this.user.password.length > max) {
        this.user.password = this.checkMaxChar(this.user.password, max, evt);
        this.hasErrorsPassword = true;
        this.checkPassword();
      } else if (validPassword !== null) {
        if (this.user.password.length > max) {
          this.user.password = this.checkMaxChar(this.user.password, max, evt);
          this.hasErrorsPassword = true;
          this.checkPassword();
        }
        this.messageForPassword = '';
        if (this.user.confirmPassword.length < min) {
          this.messageForConfirmPassword = 'visitor_sign_up_3_passwords_do_not_match';
          this.hasErrorsPassword = true;
          this.hasErrorsConfirmPassword = true;
        }
        if (this.user.confirmPassword !== '' && (this.user.confirmPassword === this.user.password)) {
          this.messageForConfirmPassword = '';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = false;
        } else {
          this.messageForConfirmPassword = 'visitor_sign_up_3_passwords_do_not_match';
          this.hasErrorsPassword = false;
          this.hasErrorsConfirmPassword = true;
        }
      } else if (validPassword === null) {
        this.hasErrorsPassword = true;
        // eslint-disable-next-line
        this.messageForPassword = 'visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from_';
      }
      if (this.user.password === '') {
        this.hasErrorsPassword = false;
        this.hasErrorsConfirmPassword = false;
      } else if (this.user.confirmPassword === '') {
        this.hasErrorsConfirmPassword = false;
      }
//      if (this.hasErrorsPassword && this.user.password.length >= min) {
//        const passwordWithoutLetter = this.user.password.match(/^(?!.*[A-Za-z]).+$/);
//        const passwordWithoutNumber = this.user.password.match(/^(?!.*\d).+$/);
//        const passwordWithSymbolsExceptUnderscore = this.user.password.match(/^(?!.*\W)_?.+$/);
//        if (passwordWithoutLetter !== null) {
//          this.messageForPassword = this.getTranslations.visitor_sign_up_3_info_msg_password_does_not_contain_at_least_one_letter;
//        } else if (passwordWithoutNumber !== null) {
//          this.messageForPassword = this.getTranslations.visitor_sign_up_3_info_msg_password_does_not_contain_at_least_one_1_digit;
//        } else if (passwordWithSymbolsExceptUnderscore === null) {
//          this.messageForPassword = this.getTranslations.visitor_forgot_password_3_msg_password_cannot_contain_any_other_symbols_except_from_;
//        }
//      }
    },
    change() {
      this.hasErrorsUsername = false;
      this.messageForUsername = '';
    },
    checkButton() {
      if (this.hasErrorsPassword || this.hasErrorsConfirmPassword || this.user.password === '' || this.user.confirmPassword === '') {
        this.message = 'visitor_forgot_password_3_wrong_password_warning_msg_at_least_6_chars';
        this.hasErrors = true;
      } else {
        // eslint-disable-next-line
        if (this.hasErrorsPassword === '') {
          this.message = 'User Refreshed the page!! Try again from step1';
          this.hasErrors = true;
        } else {
          const userData = {
            msisdn: this.forgotPasswordInfo,
            password: this.user.confirmPassword,
          };
          this.resetPassword(userData).then(() => {
            const userDataforAuthorization = {
              username: this.forgotPasswordInfo,
              password: this.user.confirmPassword,
              rememberMe: this.checkedRememberMe,
            };
            this.callForAuthorization(userDataforAuthorization).then(() => {
              if (this.getUserAuthorized) {
                this.getUserLoginDetails().then(() => {
                  this.hasErrors = false;
                  this.$router.push('/home');
                });
              } else {
                this.message = 'visitor_forgot_password_3_password_6_char_long';
                this.hasErrors = true;
              }
            });
          });
        }
      }
    },
  },
  computed: {
    ...mapState('common', [
      'facebookFunctionality',
    ]),
    ...mapState('profile', [
      'forgotPasswordInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPassword3.vue